import "./App.css";
import NotFound from "./pages/NotFound/NotFound";
import Home from "./pages/pk/home";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Weekly_star from "./pages/Weekly_star/home";
import Benefit from "./pages/benefit/home";
import CP from "./pages/cp/home";
import SpecialId from "./pages/special_id/home";
import Eid from "./pages/eid/home";

function App() {
  const { i18n } = useTranslation(); // i18n to change language
  const urlParams = new URLSearchParams(window.location.search);

  const event = urlParams.get("event_type");
  return (
    <div>
      <Router>
        <Routes>
          {event == "pk" ? (
            <Route path="/" element={<Home />} />
          ) : event == "Weekly_star" ? (
            <Route path="/" element={<Weekly_star />} />
          ) : event == "charge_benefits" ? (
            <Route path="/" element={<Benefit />} />
          ) : event == "cp" ? (
            <Route path="/" element={<CP />} />
          ) : event == "special_id" ? (
            <Route path="/" element={<SpecialId />} />
          ) : event == "eid" ? (
            <Route path="/" element={<Eid />} />
          ) : (
            <Route path="/" element={<NotFound />} />
          )}
          <Route path="/charge_benefits" element={<Benefit />} />
          <Route path="/cp" element={<CP />} />
          <Route path="/eid" element={<Eid />} />
          <Route path="*" element={<NotFound />} /> {/* Catch-all for 404 */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
